/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const StripeMetadata = core.serialization.object({
    canSelfServe: core.serialization.string().optional(),
    commitment: core.serialization.string().optional(),
    isDefaultSelection: core.serialization.string().optional(),
    interval: core.serialization.string().optional(),
    planType: core.serialization.string().optional(),
    platform: core.serialization.string().optional(),
    prepayId: core.serialization.string().optional(),
    proOnly: core.serialization.string().optional(),
    productType: core.serialization.string().optional(),
    unitLabel: core.serialization.string().optional(),
    usageType: core.serialization.string().optional(),
});
